import { clamp } from "@de-xima/xima-common-js-lang";

import { getWidgetByVar } from "./Util.ts";

/**
 * Finds a splitter component by its widgetVar and changes its size.
 * @param widgetVar The widgetVar of the splitter component.
 * @param newSize The new relative size of the first panel, between 0 and 100. The
 * second panel will automatically adjust to 100 - newSize.
 */
export function changeSplitterSizeByWidgetVar(widgetVar: string, newSize: number): void {
  const splitter = getWidgetByVar(widgetVar, PrimeFaces.widget.Splitter);
  if (splitter === undefined) {
    console.error(`Splitter with widgetVar '${widgetVar}' not found.`);
    return;
  }
  newSize = clamp(newSize, 0, 100);
  const first = splitter.panels.eq(0);
  const second = splitter.panels.eq(1);
  first.attr("data-size", newSize.toString());
  second.attr("data-size", (100 - newSize).toString());
  first.data("size", newSize);
  second.data("size", 100 - newSize);
  const originalTransitionFirst = first.css("transition");
  const originalTransitionSecond = second.css("transition");
  first.css("transition", "flex-basis 0.3s");
  second.css("transition", "flex-basis 0.3s");
  // biome-ignore lint/complexity/useLiteralKeys: We need to access an internal method
  splitter["initPanelSize"]();
  setTimeout(() => {
    if (originalTransitionFirst !== "flex-basis 0.3s") {
      first.css("transition", originalTransitionFirst);
    }
    if (originalTransitionSecond !== "flex-basis 0.3s") {
      second.css("transition", originalTransitionSecond);
    }
  }, 300);
}
